import React, { useState, useEffect } from "react";

import {
  GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
  authKey,
  GET_All_STATE,
  GET_All_DISTRICT,
  MAP_SCRUTINIZER_TO_SUPERVISOR,
  FETCH_SCRUTINIZER_SCM_MAPPING,
  GET_UNMAPPED_SCRUTINIZER,
  FETCH_GROWER_SCRUTINIZER_MAPPING,
  GET_UNMAPPED_GROWER_SCRUTINIZER,
  GET_ALL_SCRUTINIZER,
  ADD_MULTI_SCRUTINZER_SCM_MAPPING,
  GET_ALL_SCM_MEMBER,
  EDIT_SCRUTINIZER_SCM_MAPPED,
  DELETE_SCRUTINIZER_SCM_MAPPED,
  DELETE_GROWER_SCRUTINIZER_MAPPED,
  ADD_MULTI_GROWER_SCRUTINIZER_MAPPING,
  FETCH_NEW_PLANTATION_BATCH,
  ASSIGN_PLANTATION_BATCH,
  FETCH_ASSIGNED_PLANTATION_BATCH,
} from "../../../common/URLs";
import { useNavigate, useLocation } from "react-router-dom";
import { Delete as DeleteIcon, Add as AddIcon } from "@mui/icons-material";
import { loaderService } from "../../../common/custom-loader/loader-service";
import {
  BLOCK_LIST,
  REVENUE_CIRCLE,
  REVENUE_BLOCK_DEFAULT_VALUE,
  Stakeholder_Type_Mapping,
  ROLES,
  RESOURCE_ROLES,
} from "../../../common/constants";
import { Row, Col } from "react-bootstrap";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import {
  Container,
  Card,
  Link,
  CardContent,
  IconButton,
  Button,
  Tab,
  Box,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { useTranslation } from "react-i18next";
import { lastFiveDigitsComparator } from "../../../common/commonFunction";
import Iconify from "../../../common/common-sidebar/components/iconify";
import { EditIcon } from "../../../common/icons";
import apiClient from "../../../axios";

const ResScrutinizerMapping = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [viewDetails, setViewDetails] = useState(true);
  const [verifyDetails, setVerifyDetails] = useState(false);
  const [mappingtrue, setmappingtrue] = useState(false);
  const [mappingscrutrue, setmappingscrutrue] = useState(false);
  const [mappingsupervisor, setmappingsupervisor] = useState(false);
  const [scmSelected, setScmSelected] = useState("");
  const [scrutinizerSelected, setScrutinizerSelected] = useState();
  const [scmSelectedID, setScmSelectedID] = useState();
  const [scmSelectedEmail, setScmSelectedEmail] = useState();
  const [scrutinizerSelectedID, setScrutinizerSelectedID] = useState();
  const [successResponse, setSuccessResponse] = useState();
  const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
  const [
    personalRevenueCircleBlocklistLabel,
    setPersonalRevenueCircleBlocklistLabel,
  ] = useState(REVENUE_BLOCK_DEFAULT_VALUE);
  const [
    personalRevenueCircleAndBlockList,
    setPersonalRevenueCircleAndBlockList,
  ] = useState([]);
  const [scmList, setScmList] = useState([]);
  const [scrutinizerList, setScrutinizerList] = useState([]);
  const [allScrutinizerMapping, setAllScrutinizerMapping] = useState([]);
  const [allScrutinizerMappingTwo, setAllScrutinizerMappingTwo] = useState([]);
  const [mapScrutinizerApiData, setMapScrutinizerApiData] = useState([]);
  const [mapped, setMapped] = useState(false);
  const [mappedscru, setMappedscru] = useState(false);
  const [stakeholderSelected, setStakeholderSelected] = useState();
  const [stakeholderSelectedID, setStakeholderSelectedID] = useState();
  const [
    stakeholderScrutinizerSelectedID,
    setStakeholderScrutinizerSelectedID,
  ] = useState('');
  const [stakeholderScrutinizerSelected, setStakeholderScrutinizerSelected] = useState(null);
  const [
    stakeholderScrutinizerSelectedEmail,
    setStakeholderScrutinizerSelectedEmail,
  ] = useState("");
  const [stakeholderList, setStakeholderList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [itemChecked, setItemChecked] = useState([]);
  const [selectAllScru, setSelectAllScru] = useState(false);
  const [itemCheckedScru, setItemCheckedScru] = useState([]);
  const [
    allStakeholderScrutinizerMapping,
    setAllStakeholderScrutinizerMapping,
  ] = useState([]);
  const [
    stakeholderMapScrutinizerApiData,
    setStakeholderMapScrutinizerApiData,
  ] = useState([]);
  const [mapSupervisorScrutinizerApiData, setMapSupervisorScrutinizerApiData] =
    useState([]);
  const [scmToBeDeleted, setScmToBeDeleted] = useState([]);
  const [unassignedScrutinizers, setAllUnassignedScrutinizers] = useState([]);
  const [allmappedSupervisor, setAllmappedSupervisor] = useState([]);
  const [allUnmappedScrutitoSupervisor, setAllUnmappedScrutitoSupervisor] =
    useState([]);
  const [active, setActive] = useState(true);
  const [state, setStates] = useState([]);
  const [district, setDistrict] = useState([]);
  const [revenueCircle, setRevenueCircle] = useState([]);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleConfirmLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen3, setLogModalOpen3] = useState(false);
  const handleLogModalOpen3 = () => setLogModalOpen3(true);
  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleConfirmLogModalClose3 = () => setLogModalOpen3(false);
  const handleConfirmLogModalClose4 = () => setLogModalOpen4(false);
  const [logModalOpenUpdate, setLogModalOpenUpdate] = useState(false);
  const handleLogModalOpenUpdate = () => setLogModalOpenUpdate(true);
  const handleLogModalCloseUpdate = () => setLogModalOpenUpdate(false);
  const [selectedStake, setSelectedStake] = useState([]);
  const [selectedScru, setSelectedScru] = useState();
  const [selectedRowsScrutinizerToScm, setSelectedRowsScrutinizerToScm] =
    useState([]);
  const [selectedRowsScrutiToSupervisor, setSelectedRowsScrutiToSupervisor] =
    useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [selectedStakeholders, setSelectedStakeholders] = useState([]); // your selected ids
  const [highlightedRowIds, setHighlightedRowIds] = useState(new Set()); // edited rows
  const [isEditEnable, setIsEditEnable] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  console.log("selectionModel", selectionModel)
  const [supervisorSelectedID, setSupervisorSelectedID] = useState();
  const [selectedSupervisor, setSelectedSupervisor] = useState();
  const [
    supervisorScrutinizerToBeDeleted,
    setSupervisorScrutinizerToBeDeleted,
  ] = useState([]);

  const [logModalOpenConfirmScruToScm, setLogModalOpenConfirmScruToScm] =
    useState(false);
  const handleLogModalConfirmOpenScruToScm = () =>
    setLogModalOpenConfirmScruToScm(true);
  const handleLogModalConfirmCloseScruToScm = () =>
    setLogModalOpenConfirmScruToScm(false);

  const [logModalOpenStakeholder, setLogModalOpenStakeholder] = useState(false);
  const handleLogModalStakeholderOpen = () => setLogModalOpenStakeholder(true);
  const handleLogModalStakeholderClose = () =>
    setLogModalOpenStakeholder(false);

  const [logModalOpenSupervisor, setLogModalOpenSupervisor] = useState(false);
  const handleLogModalSupervisorOpen = () => setLogModalOpenSupervisor(true);
  const handleLogModalSupervisorClose = () => setLogModalOpenSupervisor(false);

  const [details, setDetails] = useState({
    selectedPersonalRevenueCircle: "",
    selectedPersonalBlockList: "",
  });

  const [searchFilter, setSearchFilter] = useState({
    stakeHolderType: "HIT",
    state: "",
    district: "",
    revenueCircleName: "",
    blockName: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    commentsError: "",
    addcommentsError: "",
    revenueError: "",
    supervisorError: "",
    scm: "",
  });

  const [tabValue, setTabValue] = React.useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSelectedStakeholders([]);
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
    setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });

    if (e.target.name === "stakeHolderType") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });
    }
    if (e.target.name === "state") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });
    }
    if (e.target.name === "district") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });
    }
    if (e.target.name === "revenueCircleName") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value });
    }
  };
  const onClickChecked = (e, urn, id) => {
    let tempARR = [...itemChecked];
    var index = tempARR.indexOf(id);
    if (index > -1) {
      tempARR.splice(index, 1);
    } else {
      tempARR.push(id);
    }
    setItemChecked(tempARR);

    setStakeholderSelected(tempARR);
    setStakeholderSelectedID(tempARR);
  };
  const onSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      let idArr = [];
      idArr.push(stakeholderList?.map((item) => item?.id));
      setItemChecked(...idArr);
      setStakeholderSelected(...idArr);
      setStakeholderSelectedID(...idArr);
    } else if (selectAll) {
      setItemChecked([]);
      setStakeholderSelectedID([]);
    }
  };
  const onClickCheckedScru = (e, email, id) => {
    let tempARR = [...itemCheckedScru];
    var index = tempARR.indexOf(id);
    if (index > -1) {
      tempARR.splice(index, 1);
    } else {
      tempARR.push(id);
    }
    setItemCheckedScru(tempARR);

    setScrutinizerSelected(tempARR);
    setScrutinizerSelectedID(tempARR);
  };
  const onSelectAllScru = () => {
    setSelectAllScru(!selectAllScru);
    if (!selectAllScru) {
      let idArr = [];
      idArr.push(unassignedScrutinizers?.map((item) => item?.id));
      setItemCheckedScru(...idArr);
      setScrutinizerSelected(...idArr);
      setScrutinizerSelectedID(...idArr);
    } else if (selectAllScru) {
      setItemCheckedScru([]);
      setScrutinizerSelectedID([]);
    }
  };

  const onClickViewDetails = () => {
    setViewDetails(true);
    setVerifyDetails(false);
    setActive(true);
  };

  const onClickVerifyDetails = () => {
    setViewDetails(false);
    setVerifyDetails(true);
    setActive(false);
  };
  useEffect(() => {
    getListOfSCMmember();
    getAllScrutinizerLeadMapping();
    getStakeholderScrutinizerMapping();
    getListOfScutinizer();
    getAllScrutinizerLeadMappingTwo();
  }, []);

  const [selectedRow, setSelectedRow] = useState();
  const [selectedRowId, setSelectedRowId] = useState("");
  const [scmEdited, setScmEdited] = useState("");
  const [scmEditedEmail, setScmEditedEmail] = useState("");

  const onEditMapping = (selectedRow) => {
    setSelectedRowId(selectedRow.id);
    setScmEdited(selectedRow.scmMemberName);
    setScmEditedEmail(selectedRow.scmMemberEmail);
  };

  const onCancelMapping = () => {
    setSelectedRowId("");
  };

  const onUpdate = (selectedRowData) => {
    setSelectedRow(selectedRowData);
    handleLogModalOpenUpdate();
  };

  // const onConfirmMappingUpdate = () => {
  //   handleLogModalCloseUpdate();
  //   editScrutinizerToScm();
  //   setSelectedRowId("");
  // };

  const onConfirmMappingUpdate = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await editScrutinizerToScm();
      await setSelectedRowId("");
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogModalOpenUpdate(false);
      setIsApiCalled(false);
    }
  };

  const onEditScm = (e) => {
    const data = scmList?.filter((item) => item.firstname === e.target.value);
    setScmEdited(data[0]?.firstname);
    setScmEditedEmail(data[0]?.scmMemberEmail);
  };

  const mapScrutinizerToScmRemove = () => {
    loaderService.showLoader();
    apiClient
      .post(
        DELETE_SCRUTINIZER_SCM_MAPPED,
        {
          id: selectedScru.id,
          scrutinizerName: selectedScru.scrutinizerName,
          scrutinizerEmail: selectedScru.scrutinizerEmail,
          scmMemberEmail: selectedScru.scmMemberEmail,
          scmMemberName: selectedScru.scmMemberName,
          createdOn: selectedScru.createdOn,
          createdBy: selectedScru.createdBy,
          isActive: selectedScru.isActive,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        // setSuccessResponse(response.data)
        if (response.data.status === "SUCCESS") {
          toast.success("Successfully removed mapping!");
          getAllScrutinizerLeadMapping();
          getAllScrutinizerLeadMappingTwo();
        } else if (response.data.status === "FAILURE") {
          toast.error(response.data.description);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const confirmDeleteScru = (selectedScru) => {
    setSelectedScru(selectedScru);
    handleLogModalOpen3();
  };
  const confirmDeleteSupervisor = (selectedSupervisor) => {
    setSelectedSupervisor(selectedSupervisor);
    handleLogModalOpen4();
  };

  const onRemoveHandle = () => {
    handleConfirmLogModalClose3();
    // const tempdata = allmappedSupervisor.filter((item) => !(item?.scrutinizerID === selectedSupervisor.scrutinizerID
    //   && item?.supervisorID === selectedSupervisor.supervisorID))

    // const deleteData = allmappedSupervisor.filter((item) => item.scrutinizerID === selectedSupervisor.scrutinizerID
    //   && item.supervisorID === selectedSupervisor.supervisorID)
    // setAllmappedSupervisor(tempdata)
    // setSupervisorScrutinizerToBeDeleted(deleteData)
    // const arr = [...supervisorScrutinizerToBeDeleted, ...deleteData]
    // const dataForApi = arr.map((item) => (
    //   {
    //     scrutinizerId: item.scrutinizerID,
    //     supervisorId: item.supervisorID,
    //     isActive: 0
    //   }))
    // setMapSupervisorScrutinizerApiData(dataForApi)
    mapScrutinizerToScmRemove();
  };

  useEffect(() => {
    getAllStates();
  }, []);

  const getAllStates = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_All_STATE,
        {},
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setStates(response.data.stateList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };
  useEffect(() => {
    if (searchFilter.state) {
      getAllDistrict();
    }
  }, [searchFilter.state]);
  const getAllDistrict = () => {
    loaderService.showLoader();

    apiClient
      .post(
        GET_All_DISTRICT,
        {
          state: searchFilter.state,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setDistrict(response.data.districtLists);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };
  useEffect(() => {
    if (searchFilter.district) {
      getAllRevnueCircleList();
    }
  }, [searchFilter.district]);
  const getAllRevnueCircleList = () => {
    loaderService.showLoader();

    apiClient
      .post(
        GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
        {
          district: searchFilter.district,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        if (searchFilter.state === "ASSAM") {
          setPersonalRevenueCircleBlocklistLabel(REVENUE_CIRCLE);
          setRevenueCircle(
            response.data.revenueCircleAndBlockList.revenueCircleLists
          );
          //setSearchFilter({ ...searchFilter, revenueCircleName: response.data.revenueCircleAndBlockList.revenueCircleLists?.[0] })
        } else {
          setPersonalRevenueCircleBlocklistLabel(BLOCK_LIST);
          setRevenueCircle(response.data.revenueCircleAndBlockList.blockLists);
          // setSearchFilter({ ...searchFilter, revenueCircleName: response.data.revenueCircleAndBlockList.blockLists?.[0] })
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };
  useEffect(() => {
    if (pincodeAddressDetails) {
      loaderService.showLoader();
      apiClient
        .post(
          GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
          {
            district: pincodeAddressDetails?.addresses[0]?.district,
          },
          {
            headers: {
              AuthKey: authKey,
            },
          }
        )
        .then((response) => {
          if (pincodeAddressDetails?.addresses[0]?.state === "ASSAM") {
            setPersonalRevenueCircleBlocklistLabel(REVENUE_CIRCLE);
            setPersonalRevenueCircleAndBlockList(
              response.data.revenueCircleAndBlockList.revenueCircleLists
            );
            if (
              response.data.revenueCircleAndBlockList.revenueCircleLists
                .length > 0
            ) {
              setDetails({
                ...details,
                selectedPersonalRevenueCircle:
                  response.data.revenueCircleAndBlockList.revenueCircleLists[0],
                selectedPersonalBlockList: "",
              });
            } else
              setDetails({ ...details, selectedPersonalRevenueCircle: "" });
          } else {
            setPersonalRevenueCircleBlocklistLabel(BLOCK_LIST);
            setPersonalRevenueCircleAndBlockList(
              response.data.revenueCircleAndBlockList.blockLists
            );
            if (response.data.revenueCircleAndBlockList.blockLists.length > 0) {
              setDetails({
                ...details,
                selectedPersonalBlockList:
                  response.data.revenueCircleAndBlockList.blockLists[0],
                selectedPersonalRevenueCircle: "",
              });
            } else setDetails({ ...details, selectedPersonalBlockList: "" });
          }
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
        });
    }
  }, [pincodeAddressDetails]);

  const getListOfSCMmember = () => {
    apiClient
      .post(
        GET_ALL_SCM_MEMBER,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setScmList(response.data.users);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getListOfScutinizer = () => {
    apiClient
      .post(
        GET_ALL_SCRUTINIZER,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setScrutinizerList(response.data.users);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getAllScrutinizerLeadMapping = () => {
    loaderService.showLoader();
    apiClient
      .post(
        FETCH_SCRUTINIZER_SCM_MAPPING,
        {
          //   "district": ""
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        setAllScrutinizerMapping(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const mapScrutinizerToScm = (dataForApi) => {
    loaderService.showLoader();
    apiClient
      .post(
        ADD_MULTI_SCRUTINZER_SCM_MAPPING,
        {
          scrutinizerScmMapping: dataForApi,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === "SUCCESS") {
          toast.success("Successfully Mapped!");
          getAllScrutinizerLeadMapping();
          getAllScrutinizerLeadMappingTwo();
        } else if (response.data.status === "FAILURE") {
          toast.error(response.data.description);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const editScrutinizerToScm = (dataForApi) => {
    loaderService.showLoader();
    apiClient
      .post(
        EDIT_SCRUTINIZER_SCM_MAPPED,
        {
          id: selectedRow.id,
          scrutinizerName: selectedRow.scrutinizerName,
          scrutinizerEmail: selectedRow.scrutinizerEmail,
          scmMemberEmail: scmEditedEmail,
          scmMemberName: scmEdited,
          createdOn: selectedRow.createdOn,
          createdBy: selectedRow.createdBy,
          isActive: selectedRow.isActive,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === "SUCCESS") {
          toast.success("Successfully Updated Mapping!");
          getAllScrutinizerLeadMapping();
        } else if (response.data.status === "FAILURE") {
          toast.error(response.data.description);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const confirmEditStake = () => {
    setIsEditEnable((prev) => {
      const next = !prev;
      if (next) setSelectionModel([]); // start fresh when enabling edit
      return next;
    });
    // if (selectedStakeholders?.length) {
    //   const rowsToDelete = allStakeholderScrutinizerMapping
    //     .filter((item) => selectedStakeholders.includes(item.plantationBatchNo))
    //     .map((item) => ({
    //       plantationBatchNo: item.plantationBatchNo,
    //       id: item.plantId,
    //       stateName: item.state,
    //       districtName: item.district,
    //       stakeholderType: item.stakeholderType,
    //       growerUrn: item.growerUrn,
    //       // status: item.status,
    //       // lastUpdatedDate: item.lastUpdatedDate,
    //       scrutinizerName: item.scrutinizerName,
    //       // scrutinizerEmail: item.scrutinizerEmail,
    //       // growerType: item.growerType,
    //     }));
    //   setSelectedStake(rowsToDelete);
    //   handleLogModalOpen();
    // } else toast.error("Please select alteast one grower to delete mapping!");
  };

  const mapScrutinizerGrowerRemove = () => {
    handleConfirmLogModalClose();
    loaderService.showLoader();
    apiClient
      .post(
        DELETE_GROWER_SCRUTINIZER_MAPPED,
        {
          growerScrutinizerMappingEntityList: selectedStake,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        // setSuccessResponse(response.data)
        if (response.data.status === "SUCCESS") {
          toast.success("Successfully removed mapping!");
          setSelectedStake([]);
          setSelectedStakeholders([]);
          getStakeholderScrutinizerMapping();
        } else if (response.data.status === "FAILURE") {
          toast.error(response.data.description);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const mapScrutinizerToSupervisor = (dataForApi) => {
    loaderService.showLoader();
    apiClient
      .post(
        MAP_SCRUTINIZER_TO_SUPERVISOR,
        {
          supervisorMappings: dataForApi,
          isSuccess: true,
          message: "string",
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        setSuccessResponse(response.data);

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const getListOfStakeholder = () => {
    // if (searchFilter.stakeHolderType === "Grower" ? searchFilter.revenueCircleName : true) {
    //   setErrorMessage({ ...errorMessage, revenueError: " " });

    loaderService.showLoader();
    apiClient
      .post(
        FETCH_NEW_PLANTATION_BATCH,

        {
          //   "pinCode": "string",
          // revenueCircle: searchFilter?.revenueCircleName
          //   ? searchFilter?.revenueCircleName
          //   : "",
          // category: "Grower",
          // state: searchFilter?.state,
          // district: searchFilter?.district ? searchFilter?.district : "",

          // "revenueCircle": personalRevenueCircleBlocklistLabel === REVENUE_CIRCLE ? details.selectedPersonalRevenueCircle : details.selectedPersonalBlockList
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setStakeholderList(response.data);
        setMapped(true);
        setStakeholderSelected([]);
        setStakeholderSelectedID([]);
        setItemChecked([]);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });

    // }
    // else {
    //   setErrorMessage({ ...errorMessage, revenueError: "Please select Revenue Circle/Block Office " });

    // }
  };
  const getAllScrutinizerLeadMappingTwo = () => {
    loaderService.showLoader();
    apiClient
      .post(
        FETCH_SCRUTINIZER_SCM_MAPPING,
        {
          //   "roleName": RESOURCE_ROLES.ResourceScrutinizer,
          //   "district": ""
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        setAllScrutinizerMappingTwo(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const getStakeholderScrutinizerMapping = () => {
    loaderService.showLoader();
    apiClient
      .post(
        FETCH_ASSIGNED_PLANTATION_BATCH,
        {
          //   "userID": "",
          //   "userRole": localStorage.getItem('role'),
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        setAllStakeholderScrutinizerMapping(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const mapStakeholderToScrutinizer = () => {
    loaderService.showLoader();
    apiClient
      .post(
        ASSIGN_PLANTATION_BATCH,
        {
          growerScrutinerAssgnRqst: stakeholderMapScrutinizerApiData,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data.status === "SUCCESS") {
          toast.success(response.data.description);
          getStakeholderScrutinizerMapping();
          setStakeholderScrutinizerSelected(null);
          setStakeholderScrutinizerSelectedEmail("");
          setStakeholderScrutinizerSelectedID('');
          setErrorMessage({ ...errorMessage, addcommentsError: "" });
          handleEditSuccess();
        } else if (response.data.status === "FAILURE") {
          toast.error(response.data.description);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const getallunmappedscrutinizers = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_UNMAPPED_SCRUTINIZER,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        }
      )
      .then((response) => {
        setAllUnassignedScrutinizers(response.data.users);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const onChangeScm = (e) => {
    let selectedScrutinizer = scmList?.find(
      (item) => item.id === e.target.value
    );
    setScmSelected(selectedScrutinizer?.firstname);
    setScmSelectedID(selectedScrutinizer?.id);
    setScmSelectedEmail(selectedScrutinizer?.emailAddress);
  };

  const onChangeStakeholderScrutinizer = (e) => {
    let selectedScrutinizer = allScrutinizerMappingTwo.filter(
      (item) => item.id === e.target.value
    );
    setStakeholderScrutinizerSelected(selectedScrutinizer[0].scrutinizerName);
    setStakeholderScrutinizerSelectedID(selectedScrutinizer[0].id);
    setStakeholderScrutinizerSelectedEmail(
      selectedScrutinizer[0].scrutinizerEmail
    );
    setErrorMessage({ ...errorMessage, addcommentsError: "" });
  };

  const onStakeholderScrutinizerAdd = () => {
    handleLogModalStakeholderClose();
    mapStakeholderToScrutinizer();
  };
  const onScrutinizerAdd = () => {
    handleLogModalConfirmCloseScruToScm();
    if (scmSelected && selectedRowsScrutinizerToScm) {
      setErrorMessage({ ...errorMessage, commentsError: " " });
      let errormsg = false;
      let tempArr = [...allScrutinizerMapping];
      let apiArr = [...mapScrutinizerApiData];
      const arr = [...selectedRowsScrutinizerToScm, ...apiArr];
      const rows = unassignedScrutinizers.filter((item) =>
        selectedRowsScrutinizerToScm.includes(item.id)
      );
      const apiObjData = rows.map((item) =>
        scmSelectedID === item.id
          ? (errormsg = true)
          : {
            // id: item.id,
            scrutinizerName: item.firstname,
            scrutinizerEmail: item.emailAddress,
            scmMemberEmail: scmSelectedEmail,
            scmMemberName: scmSelected,
            // createdOn: "",
            // createdBy: "",
            // updatedOn: "",
            // updatedBy: "",
            // isActive: 1,
          }
      );
      const objCreated = {
        scmID: scmSelectedID,
        scmName: scmSelected,
        scrutinizerID: scrutinizerSelectedID,
        scrutinizerName: scrutinizerSelected,
      };
      if (errormsg === true) {
        setErrorMessage({
          ...errorMessage,
          commentsError: "Cannot map users with same Id's ",
        });
      } else {
        setMapScrutinizerApiData(apiObjData);
        setmappingscrutrue(false);
        mapScrutinizerToScm(apiObjData);
      }
    } else {
      setErrorMessage({
        ...errorMessage,
        commentsError: "Select one Lead Scrutinizer and Scrutinizer",
      });
    }
  };
  const onScrutinizerSupervisorAdd = () => {
    handleLogModalSupervisorClose();
    if (supervisorSelectedID && selectedRowsScrutiToSupervisor) {
      setErrorMessage({ ...errorMessage, supervisorError: "" });

      let tempArr = [...allmappedSupervisor];
      let apiArr = [...mapSupervisorScrutinizerApiData];
      const arr = [...selectedRowsScrutiToSupervisor, ...apiArr];
      const apiObjData = arr.map((item) => ({
        supervisorId: supervisorSelectedID,
        scrutinizerId: item,
        isActive: 1,
      }));
      const objCreated = {
        supervisorId: supervisorSelectedID,
        scrutinizerId: selectedRowsScrutiToSupervisor,
      };
      setMapScrutinizerApiData(apiObjData);
      setMapSupervisorScrutinizerApiData(apiObjData);
      setmappingscrutrue(false);
      mapScrutinizerToSupervisor(apiObjData);
    } else {
      setErrorMessage({
        ...errorMessage,
        supervisorError: "Select one Supervisor and Scrutinizer",
      });
    }
  };

  const addnewBtnClick = () => {
    setmappingtrue(true);
    setMapped(false);
    setStakeholderMapScrutinizerApiData([]);
    setStakeholderSelected([]);
    setStakeholderSelectedID([]);
    setItemChecked([]);
    setSelectedStakeholders([]);
    getListOfStakeholder();
  };
  const addnewBtnClickScru = () => {
    getallunmappedscrutinizers();
    setmappingscrutrue(true);
    setMapScrutinizerApiData([]);
    setErrorMessage({ ...errorMessage, addcommentsError: "" });
  };

  function goCancel() {
    setmappingtrue(false);
    setSelectedStakeholders([]);
    setStakeholderMapScrutinizerApiData([]);
    setStakeholderSelected([]);
    setStakeholderSelectedID([]);
    setErrorMessage({ ...errorMessage, addcommentsError: "" });
  }
  function goCancelscru() {
    setmappingscrutrue(false);
    setMapped(true);
  }
  const addnewBtnClickSupervisor = () => {
    setmappingsupervisor(true);
    setMapSupervisorScrutinizerApiData([]);
  };
  function goCancelSupervisor() {
    setmappingsupervisor(false);
  }

  const mappedScrutinizerCol = [
    {
      field: "id",
      headerName: "S.No.",
      width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1,
    },
    { field: "scrutinizerName", headerName: "Scrutinizer", width: 250 },
    {
      field: "scmMemberName",
      headerName: "Plantation Manager",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            {params.row.id === selectedRowId ? (
              <FormControl fullWidth size="small">
                <InputLabel>Plantation Manager</InputLabel>
                <Select
                  value={scmEdited}
                  label="Plantation Manager"
                  onChange={(e) => onEditScm(e)}
                >
                  <MenuItem disabled selected value="">
                    {" "}
                    -- select an option --{" "}
                  </MenuItem>
                  {scmList?.map((item) => (
                    <MenuItem value={item?.firstname}>
                      {item?.firstname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              params.row.scmMemberName
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => {
        return (
          <>
            {params.row.id === selectedRowId ? (
              <Box display="flex" alignItems="center" justifyContent="center">
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => onUpdate(params?.row)}
                >
                  {t("reg.update")}
                </Button>
                <Button
                  size="small"
                  sx={{ ml: 2 }}
                  variant="outlined"
                  onClick={() => onCancelMapping(params?.row)}
                >
                  {t("reg.cancel")}
                </Button>
              </Box>
            ) : (
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  onClick={() => onEditMapping(params?.row)}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Delete">
              <IconButton
                style={{ color: "red" }}
                onClick={() => confirmDeleteScru(params?.row)}
                component="label"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  const mappedStakeholderCol = [
    {
      field: "id",
      headerName: "S.No.",
      width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.plantationBatchNo) + 1,
    },
    {
      field: "growerUrn",
      headerName: "URN",
      width: 130,
      sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      renderCell: (params) => {
        return (
          <Link
            to={params}
            onClick={() => {
              onView(
                params?.row?.growerUrn,
                params?.row?.stakeholderType,
                params?.row?.growerType
              );
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    { field: "growerName", headerName: "Name", width: 150 },
    { field: "district", headerName: "District", width: 150 },
    { field: "state", headerName: "State", width: 180 },
    { field: "scrutinizerName", headerName: "Scrutinizer Name", width: 180 },
    { field: "landName", headerName: "Land Name", width: 180 },
    { field: "plantationBatchNo", headerName: "Plantation Batch No.", width: 180 },
    // {
    //   field: 'action', headerName: 'Action', width: 60,
    //   renderCell: (index) => {
    //     return (
    //       <IconButton style={{ color: 'red' }} onClick={() => confirmDeleteStake(index?.row)} component="label">
    //         <DeleteIcon />
    //       </IconButton>
    //     );

    //   }
    // },
  ];

  const unmappedScrutinizerCol = [
    {
      field: "firstname",
      headerName: "Scrutinizer Name",
      width: 220,
      // valueGetter: (params) => {
      //   if (params) {
      //     return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname
      //   } else return '-'
      // }
    },
    { field: "emailAddress", headerName: "Email Address", width: 200 },
    // { field: 'state', headerName: 'State', width: 200 },
  ];
  const unmappedSupervisorCol = [
    {
      field: "firstname",
      headerName: "Scrutinizer",
      width: 220,
      valueGetter: (params) => {
        if (params) {
          return (
            params.row.firstname +
            " " +
            params.row.middlename +
            " " +
            params.row.lastname
          );
        } else return "-";
      },
    },
    { field: "emailAddress", headerName: "Email Address", width: 200 },
  ];
  const unmappedStakeholderCol = [
    {
      field: "growerUrn",
      headerName: "URN",
      width: 200,
      sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
    },
    {
      field: "growerName",
      headerName: t("preReg.name"),
      width: 180,
      renderCell: (params) =>
        params.row.subCategory &&
          params.row.subCategory.toLowerCase() == "individual"
          ? params.row.contactPersonFirstname +
          (params.row.contactPersonMiddlename
            ? " " + params.row.contactPersonMiddlename
            : "") +
          " " +
          params.row.contactPersonLastname
          : params.row.growerName,
    },
    {
      field: "district",
      headerName: "State",
      width: 110,
    },
    {
      field: "state",
      headerName: "State",
      width: 110,
    },
    { field: "landName", headerName: "Land Name", width: 180 },
    { field: "plantationBatchNo", headerName: "Plantation Batch No.", width: 220 },
  ];

  const onAddScrutinizerToScmMapping = () => {
    if (selectedRowsScrutinizerToScm?.length == 0) {
      toast.error("Select atleast one scrutinizer to map");
    } else if (!scmSelected) {
      setErrorMessage({ ...errorMessage, scm: "please select the Plantation Manager" });
    } else handleLogModalConfirmOpenScruToScm();
  };

  const confirmStakeholderSubmission = (mappingState) => {
    if (selectedStakeholders?.length === 0 && selectionModel?.length === 0) {
      toast.error("Please select atlease one grower!");
    } else if (!stakeholderScrutinizerSelected) {
      setErrorMessage({
        ...errorMessage,
        addcommentsError: "Please select scrutinizer",
      });
    } else if (mappingState === "Add") {
      setErrorMessage({ ...errorMessage, addcommentsError: "" });
      const rows = stakeholderList?.filter((item) =>
        selectedStakeholders?.includes(item.plantationBatchNo)
      );
      const apiObjData = rows.map((item) => ({
        // stateName: item.state,
        // districtName: item.district,
        // stakeholderType: item.categoryName,
        // growerUrn: item.growerUrn,
        // status: item.registrationStatus,
        // lastUpdatedDate: item.lastUpdatedDate,
        // scrutinizerName: stakeholderScrutinizerSelected,
        // scrutinizerEmail: stakeholderScrutinizerSelectedEmail,
        // growerType: item.growerType,
        plantatioBatchNo: item.plantationBatchNo,
        scrutinizerName: stakeholderScrutinizerSelected,
        scrutinizerEmail: stakeholderScrutinizerSelectedEmail,
        plantId: item?.plantId
      }));

      setStakeholderMapScrutinizerApiData(apiObjData);
      // mapStakeholderToScrutinizer(apiObjData);
      setMapped(false);
      setmappingtrue(false);
      handleLogModalStakeholderOpen();
    } else if (mappingState === "Update") {
      setErrorMessage({ ...errorMessage, addcommentsError: "" });
      const toUpdateRows = allStakeholderScrutinizerMapping?.filter((item) =>
        selectionModel?.includes(item.plantationBatchNo)
      );
      const apiObjData = toUpdateRows.map((item) => ({
        // id: item.id,
        // stateName: item.stateName,
        // districtName: item.districtName,
        // stakeholderType: item.stakeholderType,
        // growerUrn: item.growerUrn,
        // status: item.status,
        // lastUpdatedDate: item.lastUpdatedDate,
        // scrutinizerName: stakeholderScrutinizerSelected,
        // scrutinizerEmail: stakeholderScrutinizerSelectedEmail,
        // growerType: item.growerType,

        plantatioBatchNo: item.plantationBatchNo,
        scrutinizerName: stakeholderScrutinizerSelected,
        scrutinizerEmail: stakeholderScrutinizerSelectedEmail,
        plantId: item?.plantId
      }));
      setStakeholderMapScrutinizerApiData(apiObjData);
      // mapStakeholderToScrutinizer(apiObjData);
      setMapped(false);
      setmappingtrue(false);
      handleLogModalStakeholderOpen();
    }
  };

  const confirmSupervisorSubmission = () => {
    handleLogModalSupervisorOpen();
  };
  const onView = (urnSelected, stakeholderType, growerSubCategory) => {
    const userData = {
      urnSelected: urnSelected,
      isScrutinyView: true,
    };
    // if (stakeholderType === "Transporter") {
    //   navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
    // }
    // else if (stakeholderType === "HIT") {
    //   navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
    // }
    // else if (stakeholderType === "LLE") {
    //   navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
    // }
    // else if (stakeholderType === "Interim Storage Operator") {
    //   navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
    // }
    if (
      growerSubCategory == "Individual" ||
      growerSubCategory == "JFMC" ||
      growerSubCategory === "Other Agency"
    ) {
      navigate("/registrationHome/dashboard/registrationDetails", {
        state: { data: userData, URN: urnSelected },
      });
    } else if (
      growerSubCategory === "Co-operative" ||
      growerSubCategory === "FPO" ||
      growerSubCategory === "SHG" ||
      growerSubCategory === "FPC"
    ) {
      navigate("/registrationHome/dashboard/registrationMemberDetails", {
        state: { data: userData, URN: urnSelected },
      });
    } else if (
      growerSubCategory === "Forest"
    ) {
      navigate("/registrationHome/dashboard/registrationDetailsForest", {
        state: { data: userData, URN: urnSelected },
      });
    } else {
      // navigate("/registrationHome/dashboard/onView", { state: { data: userData } });
    }
  };

  const handleEditSuccess = () => {
    // keep highlight of edited rows
    setHighlightedRowIds((prev) => {
      const next = new Set(prev);
      selectionModel.forEach((id) => next.add(id));
      return next;
    });

    //  MUST clear selection so next time edit opens, nothing is pre-selected
    setSelectionModel([]);

    //  disable edit mode (checkbox disappears)
    setIsEditEnable(false);
  };

  return (
    <div>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG58</p>}
      <Card>
        <CardContent>
          <Container fluid>
            <Row>
              <Col xs={12} md={12}>
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleTabChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab label="Scrutinizer Mapping" value="1" />
                      <Tab label="Stakeholder Mapping" value="2" />
                    </TabList>
                  </Box>
                  <TabPanel value="1" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                    <div>
                      {mappingscrutrue === true ? (
                        <div>
                          <Row className="row_search">
                            {mappingscrutrue === true ? (
                              <div>
                                <div
                                  className="table-header-mappedtxt"
                                  style={{
                                    marginTop: "1vh",
                                    marginBottom: "1vh",
                                  }}
                                >
                                  Unmapped Scrutinizers
                                </div>
                                <Box
                                  sx={{
                                    height: 500,
                                    width: "100%",
                                    "& .MuiDataGrid-cell--editable": {
                                      bgcolor: (theme) =>
                                        theme.palette.mode === "dark"
                                          ? "#376331"
                                          : "rgb(217 243 190)",
                                    },
                                  }}
                                >
                                  {unassignedScrutinizers && (
                                    <DataGrid
                                      style={{ marginLeft: "1vw" }}
                                      rows={unassignedScrutinizers}
                                      columns={unmappedScrutinizerCol}
                                      pageSize={[10]}
                                      components={{
                                        Toolbar: QuickSearchToolbar,
                                      }}
                                      checkboxSelection
                                      onSelectionModelChange={(
                                        newSelection
                                      ) => {
                                        setSelectedRowsScrutinizerToScm(
                                          newSelection.map((row) => {
                                            let sno = "";
                                            unassignedScrutinizers.forEach(
                                              (sch) => {
                                                if (row == sch.id) {
                                                  sno = sch.id;
                                                }
                                              }
                                            );
                                            return sno;
                                          })
                                        );
                                      }}
                                    />
                                  )}
                                </Box>
                                <div>
                                  <Row>
                                    <Col xs={12} md={4}>
                                      <FormControl
                                        fullWidth
                                        style={{
                                          marginLeft: "2vh",
                                          marginTop: "2vh",
                                        }}
                                      >
                                        <InputLabel>Plantation Manager</InputLabel>
                                        <Select
                                          value={scmSelectedID}
                                          label="Plantation Manager"
                                          onChange={(e) => onChangeScm(e)}
                                        >
                                          <MenuItem disabled selected value="">
                                            {" "}
                                            -- select an option --{" "}
                                          </MenuItem>
                                          {scmList?.map((item) => (
                                            <MenuItem value={item?.id}>
                                              {item?.firstname}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Col>
                                    <Col xs={12} md={4}></Col>
                                    <Col xs={0} md={4}>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        mt={3}
                                        style={{ float: "right" }}
                                      >
                                        <Button
                                          sx={{ minWidth: 100 }}
                                          variant="contained"
                                          onClick={onAddScrutinizerToScmMapping}
                                        >
                                          Add
                                        </Button>
                                        <Button
                                          sx={{ minWidth: 100, ml: "2vh" }}
                                          variant="contained"
                                          onClick={() => goCancelscru()}
                                        >
                                          Cancel
                                        </Button>
                                      </Box>
                                    </Col>
                                    <div className="errorText_lle1">
                                      {errorMessage.commentsError}
                                    </div>
                                  </Row>
                                </div>{" "}
                              </div>
                            ) : null}
                          </Row>
                        </div>
                      ) : (
                        <div>
                          <Row>
                            <Col xs={12} md={4}>
                              <div className="table-header-mappedtxt">
                                Mapped Scrutinizers
                              </div>
                            </Col>
                            <Col xs={12} md={4}></Col>
                            <Col xs={12} md={4}>
                              <Button
                                style={{ float: "right", marginBottom: "2vh" }}
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => addnewBtnClickScru()}
                              >
                                Add New Mapping
                              </Button>
                            </Col>
                          </Row>
                          <Box
                            sx={{
                              height: 500,
                              width: "100%",
                              "& .MuiDataGrid-cell--editable": {
                                bgcolor: (theme) =>
                                  theme.palette.mode === "dark"
                                    ? "#376331"
                                    : "rgb(217 243 190)",
                              },
                            }}
                          >
                            {allScrutinizerMapping && (
                              <DataGrid
                                style={{ marginLeft: "1vw" }}
                                rows={allScrutinizerMapping}
                                columns={mappedScrutinizerCol}
                                pageSize={[10]}
                                getRowId={(row) => row?.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                              />
                            )}
                          </Box>
                          <div className="short-wait-div"></div>
                        </div>
                      )}
                    </div>
                  </TabPanel>
                  <TabPanel value="2" style={{ padding: "2vh 0vh 0vh 0vh" }}>
                    <>
                      {mappingtrue === true ? (
                        <>
                          <Row className="row_search">
                            {/* <Row>
                              <Col xs={12} md={3}>
                                <FormControl fullWidth>
                                  <InputLabel>Stakeholder Type</InputLabel>
                                  <Select
                                    name="stakeHolderType"
                                    label="Stakeholder Type"
                                    value="Grower"
                                  >
                                    <MenuItem selected value="Grower">
                                      Grower
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Col>
                            </Row> */}
                            {/* {searchFilter.stakeHolderType === "Grower" ?  */}

                            <Row>
                              {" "}
                              {/* <Col xs={12} md={3} style={{ marginTop: "1vh" }}>
                                <FormControl fullWidth>
                                  <InputLabel>State</InputLabel>
                                  <Select
                                    name="state"
                                    label="State"
                                    onChange={(e) => handleChange(e)}
                                    value={searchFilter.state}
                                  >
                                    <MenuItem disabled selected value="">
                                      {" "}
                                      -- select an option --{" "}
                                    </MenuItem>
                                    {state?.map((item) => (
                                      <MenuItem key={item} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Col> */}
                              {/* <Col xs={12} md={3} style={{ marginTop: "1vh" }}>
                                <FormControl fullWidth>
                                  <InputLabel>District</InputLabel>
                                  <Select
                                    name="district"
                                    label="District"
                                    onChange={(e) => handleChange(e)}
                                    value={searchFilter.district}
                                  >
                                    <MenuItem selected value="">
                                      {" "}
                                      -- select an option --{" "}
                                    </MenuItem>
                                    {district?.map((item) => (
                                      <MenuItem key={item} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Col> */}
                              {/* <Col xs={12} md={4} style={{ marginTop: "1vh" }}>
                                <FormControl fullWidth>
                                  <InputLabel>
                                    RevenueCircle/BlockOffice
                                  </InputLabel>
                                  <Select
                                    name="revenueCircleName"
                                    label="RevenueCircle/BlockOffice"
                                    onChange={(e) => handleChange(e)}
                                    value={searchFilter.revenueCircleName}
                                  >
                                    <MenuItem selected value="">
                                      {" "}
                                      -- select an option --{" "}
                                    </MenuItem>
                                    {revenueCircle?.map((item) => (
                                      <MenuItem key={item} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Col> */}
                            </Row>
                            {/* //   : null} */}
                            <Col xs={0} md={1}></Col>
                            <Row>
                              {/* <Col xs={0} md={8}></Col>
                              <Col xs={12} md={4}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  mt={3}
                                  style={{ float: "right" }}
                                >
                                  <Button
                                    sx={{ minWidth: 100 }}
                                    variant="contained"
                                    onClick={() => getListOfStakeholder()}
                                  >
                                    Search
                                  </Button>
                                  <Button
                                    sx={{ minWidth: 100, ml: 1 }}
                                    variant="contained"
                                    onClick={() => goCancel()}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </Col> */}
                              {/* <div className="errorText_lle1">
                                {errorMessage.revenueError}
                              </div> */}
                            </Row>
                            {mapped === true ? (
                              <div>
                                <div
                                  className="table-header-mappedtxt"
                                  style={{
                                    marginTop: "1vh",
                                    marginBottom: "1vh",
                                  }}
                                >
                                  Unmapped Stakeholders
                                </div>
                                <Box
                                  sx={{
                                    height: 500,
                                    width: "100%",
                                    "& .MuiDataGrid-cell--editable": {
                                      bgcolor: (theme) =>
                                        theme.palette.mode === "dark"
                                          ? "#376331"
                                          : "rgb(217 243 190)",
                                    },
                                  }}
                                >
                                  {stakeholderList && (
                                    <DataGrid
                                      style={{ marginLeft: "1vw" }}
                                      rows={stakeholderList}
                                      columns={unmappedStakeholderCol}
                                      pageSize={[10]}
                                      getRowId={(row) => row.plantationBatchNo}
                                      components={{
                                        Toolbar: QuickSearchToolbar,
                                      }}
                                      checkboxSelection
                                      onSelectionModelChange={(
                                        newSelection
                                      ) => {
                                        setSelectedStakeholders(
                                          newSelection.map((row) => {
                                            let sno = "";

                                            stakeholderList.forEach((sch) => {
                                              if (row == sch.plantationBatchNo) {
                                                sno = sch.plantationBatchNo;
                                              }
                                            });

                                            return sno;
                                          })
                                        );
                                      }}
                                    />
                                  )}
                                </Box>
                                <div>
                                  <Row className="row_mapping_screens">
                                    <Col xs={12} md={4}>
                                      <FormControl
                                        fullWidth
                                        style={{ marginTop: "2vh" }}
                                      >
                                        <InputLabel>Scrutinizer</InputLabel>
                                        <Select
                                          label="Scrutinizer"
                                          value={
                                            stakeholderScrutinizerSelectedID
                                          }
                                          onChange={(e) =>
                                            onChangeStakeholderScrutinizer(e)
                                          }
                                        >
                                          <MenuItem disabled selected value>
                                            {" "}
                                            -- select an option --{" "}
                                          </MenuItem>
                                          {allScrutinizerMappingTwo.map(
                                            (item) => (
                                              // <MenuItem value={item.scrutinizerID}>{item.scrutinizerName}</MenuItem>
                                              <MenuItem value={item.id}>
                                                {item.scrutinizerName}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </Col>
                                    <Col xs={12} md={6}></Col>
                                    <Col xs={0} md={2}>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        mt={3}
                                        style={{ float: "right" }}
                                      >
                                        <Button
                                          sx={{ minWidth: 100 }}
                                          variant="contained"
                                          onClick={() =>
                                            confirmStakeholderSubmission("Add")
                                          }
                                        >
                                          Add
                                        </Button>
                                        <Button
                                          sx={{ minWidth: 100, ml: 1 }}
                                          variant="outlined"
                                          onClick={() => goCancel()}
                                        >
                                          Cancel
                                        </Button>
                                      </Box>
                                    </Col>
                                    <div className="errorText_lle1">
                                      {errorMessage.addcommentsError}
                                    </div>
                                  </Row>
                                </div>
                              </div>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row>
                            <Col xs={12} md={6} lg={6}>
                              <div className="table-header-mappedtxt">
                                Mapped Stakeholders
                              </div>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                mb={2}
                                style={{ float: "right" }}
                              >
                                <Button
                                  variant="contained"
                                  startIcon={<AddIcon />}
                                  onClick={() => addnewBtnClick()}
                                >
                                  Add New Mapping
                                </Button>
                                <Button
                                  sx={{ ml: 2 }}
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => confirmEditStake()}
                                >
                                  <EditIcon />
                                  Edit
                                </Button>
                              </Box>
                            </Col>
                          </Row>
                          <Box
                            sx={{
                              height: 500,
                              width: "100%",
                              "& .MuiDataGrid-cell--editable": {
                                bgcolor: (theme) =>
                                  theme.palette.mode === "dark"
                                    ? "#376331"
                                    : "rgb(217 243 190)",
                              },
                            }}
                          >
                            {allStakeholderScrutinizerMapping && (
                              <DataGrid sx={{
                                "& .row-edited": { backgroundColor: "rgba(255, 235, 59, 0.35)" },
                                "& .row-edited:hover": { backgroundColor: "rgba(255, 235, 59, 0.5)" },
                              }}
                                style={{ marginLeft: '1%' }}
                                rows={allStakeholderScrutinizerMapping}
                                columns={mappedStakeholderCol}
                                getRowId={(row) => row.plantationBatchNo}
                                checkboxSelection={isEditEnable}
                                disableSelectionOnClick={!isEditEnable}

                                //  controlled selection (v5)
                                selectionModel={selectionModel}
                                onSelectionModelChange={(newSelection) => {
                                  if (!isEditEnable) return;       // block selection when disabled
                                  setSelectionModel(newSelection); // updates ticks
                                }}

                                // highlight edited rows
                                getRowClassName={(params) =>
                                  highlightedRowIds.has(params.id) ? "row-edited" : ""
                                }
                                components={{ Toolbar: QuickSearchToolbar }}
                              />
                            )}
                          </Box>
                          <Row className="row_mapping_screens">
                            <Col xs={12} md={4}>
                              <FormControl
                                fullWidth
                                style={{ marginTop: "2vh" }}
                              >
                                <InputLabel>Scrutinizer</InputLabel>
                                <Select
                                  label="Scrutinizer"
                                  value={stakeholderScrutinizerSelectedID}
                                  onChange={(e) =>
                                    onChangeStakeholderScrutinizer(e)
                                  }
                                >
                                  <MenuItem disabled selected value>
                                    {" "}
                                    -- select an option --{" "}
                                  </MenuItem>
                                  {allScrutinizerMappingTwo.map((item) => (
                                    // <MenuItem value={item.scrutinizerID}>{item.scrutinizerName}</MenuItem>
                                    <MenuItem value={item.id}>
                                      {item.scrutinizerName}
                                    </MenuItem>
                                  ))}
                                </Select>
                                <div className="errorText_lle1">
                                  {errorMessage.addcommentsError}
                                </div>
                              </FormControl>
                            </Col>
                            <Col xs={12} md={6}></Col>
                            <Col xs={0} md={2}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                mt={3}
                                style={{ float: "right" }}
                              >
                                <Button
                                  sx={{ minWidth: 100 }}
                                  variant="contained"
                                  onClick={() =>
                                    confirmStakeholderSubmission("Update")
                                  }
                                >
                                  Update
                                </Button>
                              </Box>
                            </Col>
                          </Row>
                          {/* <div className="short-wait-div" >
                          </div> */}
                        </>
                      )}
                    </>
                  </TabPanel>
                </TabContext>
              </Col>
            </Row>
          </Container>
          <ConfirmationPopover
            onOpen={logModalOpen}
            onConfirm={mapScrutinizerGrowerRemove}
            action="Delete"
            onClose={handleConfirmLogModalClose}
          />
          <ConfirmationPopover
            onOpen={logModalOpen3}
            onConfirm={onRemoveHandle}
            action="Delete"
            onClose={handleConfirmLogModalClose3}
          />
          {/* <ConfirmationPopover onOpen={logModalOpen4} onConfirm={onScmScrutinizerRemove} action="Delete" onClose={handleConfirmLogModalClose4} /> */}
          <ConfirmationPopover
            onOpen={logModalOpenConfirmScruToScm}
            onConfirm={onScrutinizerAdd}
            action="Submit"
            onClose={handleLogModalConfirmCloseScruToScm}
          />
          <ConfirmationPopover
            onOpen={logModalOpenStakeholder}
            onConfirm={onStakeholderScrutinizerAdd}
            action="Submit"
            onClose={handleLogModalStakeholderClose}
          />
          <ConfirmationPopover
            onOpen={logModalOpenSupervisor}
            onConfirm={onScrutinizerSupervisorAdd}
            action="Submit"
            onClose={handleLogModalSupervisorClose}
          />
          <ConfirmationPopover
            onOpen={logModalOpenUpdate}
            onConfirm={onConfirmMappingUpdate}
            action="Update"
            onClose={handleLogModalCloseUpdate}
          />
        </CardContent>
      </Card>
    </div>
  );
};
export default ResScrutinizerMapping;
